import { render, staticRenderFns } from "./OrderPromoCode.vue?vue&type=template&id=14aa3a3e&"
import script from "./OrderPromoCode.vue?vue&type=script&lang=ts&"
export * from "./OrderPromoCode.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPromoCode.vue?vue&type=style&index=0&id=14aa3a3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInput: require('/usr/www/nuxt/components/Base/BaseInput.vue').default})
